import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "photobooth" }
const _hoisted_2 = { class: "video-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "video-countdown"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

import { setIntervalX } from '@/api/utils';
import store from '@/store';
import { computed } from '@vue/reactivity';
import { onMounted, reactive, ref } from 'vue'
import Webcam from 'webcam-easy'


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoBooth',
  props: {
    countdown: null
  },
  emits: ['photo'],
  setup(__props: any, { emit }) {

const props = __props as {
  countdown: number
}

const webcamElement = ref<HTMLElement | null>(null)
const outputImage = ref<HTMLImageElement | null>(null)
const canvasElement = ref<HTMLCanvasElement | null>(null)

const user = computed(() => store.getCurrentUser())



const state = reactive({
  photoSnapped: false,
  showCounter: false,
  counter: props.countdown || 7,
  imageSrc: ''
})



const downloadCanvas = (canvas: HTMLCanvasElement) => {
  var link = document.createElement('a');
  link.download = 'filename.png';
  link.href = canvas.toDataURL()
  link.click();
}

onMounted(() => {
  if (webcamElement.value && canvasElement.value) {
    const webcam = new Webcam(webcamElement.value, 'user', canvasElement.value) as any;
    
    console.log(webcam);
    webcam.start()
    .then((result: any) =>{
        state.showCounter = true

        setIntervalX(() => {
          state.counter--
        }, 1000, state.counter)

        console.log("webcam started");
        setTimeout(() => {
          const photo = webcam.snap()
          state.showCounter = false
          state.photoSnapped = true
          state.imageSrc = photo
          
          setTimeout(() =>  {
            emit('photo', photo)
          }, 3000)

        }, state.counter * 1000)
    })
    .catch((err: any) => {
        console.log(err);
    });
  }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (state.showCounter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(state.counter), 1)
            ]))
          : _createCommentVNode("", true),
        (!state.photoSnapped)
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              ref_key: "webcamElement",
              ref: webcamElement,
              id: "webcam",
              autoplay: "",
              playsinline: "",
              width: "640",
              height: "480"
            }, null, 512))
          : _createCommentVNode("", true),
        (state.imageSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: state.imageSrc,
              ref_key: "outputImage",
              ref: outputImage
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("canvas", {
          ref_key: "canvasElement",
          ref: canvasElement,
          hidden: ""
        }, null, 512)
      ]),
      (state.photoSnapped)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Perfekt!"))
        : (state.counter > 3)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_6, "Smile" + _toDisplayString(_unref(user) && _unref(user).registered ? ' ' + _unref(user).name : '') + "!", 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_7, "Get ready!"))
    ])
  ]))
}
}

})